import { find, flatten, get, isEmpty, keys, toUpper, values } from 'lodash'

const getNodeToMoveTo = (
  keywordsState,
  flattenKeywordsGroupedByField,
  shouldGetParentIfSubtype = false,
) => {
  const { checkedKeywordKeys } = keywordsState

  const typeToMoveTo = find(
    keys(checkedKeywordKeys),
    keywordType => !isEmpty(get(checkedKeywordKeys, keywordType)),
  )

  const nodeKeyToMoveTo = get(checkedKeywordKeys, `${typeToMoveTo}[0]`)

  const nodeToMoveTo = find(
    flatten(values(flattenKeywordsGroupedByField)),
    ({ key, type }) =>
      key === nodeKeyToMoveTo && type === toUpper(typeToMoveTo),
  )

  if (!shouldGetParentIfSubtype) {
    return { nodeToMoveTo }
  }

  const parentNodeToMoveTo = nodeToMoveTo.isSubtype
    ? find(
        flatten(values(flattenKeywordsGroupedByField)),
        ({ id, type }) =>
          id === nodeToMoveTo.parentId && type === toUpper(typeToMoveTo),
      )
    : null

  return { nodeToMoveTo, parentNodeToMoveTo }
}

export default getNodeToMoveTo
